// Mirrors the backend bounds on POST /api/admin/recordings/{id}/reveal-transcript.
export const REVEAL_REASON_MIN = 10;
export const REVEAL_REASON_MAX = 1000;

export function isValidRevealReason(reason: string): boolean {
  const length = reason.trim().length;
  return length >= REVEAL_REASON_MIN && length <= REVEAL_REASON_MAX;
}
